import Breadcrumbs from './Breadcrumbs';
import './Breadcrumbs.scss';

export default Breadcrumbs;
